import React from 'react';
//@ts-ignore
import Slider from "react-slick";
import Button from './../button/./button';
// @ts-ignore
import {GetYoutubeIdFromUrl} from './../../themes/kent/utilities/functions';
// @ts-ignore
import YoutubeBackground from 'react-youtube-background';
/**
 *
 * Slider Component
 * @extends {React.Component}
 */
interface IProps {
  dots?: any;
  infinite?:boolean;
  slides?: any;
  arrows?:boolean;
  autoPlay?:boolean;
  height?:any;
  theme?:any;
}

class BaseSlider extends React.Component<IProps>{

  constructor(props: IProps) {
    super(props);
  }
  public render(): JSX.Element {
    let heightClass = this.props.height ? cssClassCoversionDictionary[this.props.height]+'-height' : '';
    let color = this.props.theme === 'dark' ? '#fff' : '#000';
    let settings = {
      infinite: this.props.infinite ? true : false,
      //autoplay: this.props.autoPlay ? true : false,
      autoplay:false,
      autoplaySpeed:5000,
      fade:false,
      arrows:this.props.arrows ? true : false,
      pauseOnHover:true
    };

    return (
    <div className="hosports-slider">
     <Slider {...settings}>
      {this.props.slides && this.props.slides.map((slide:any) =>{
        let textPlacementClass = slide.textPlacement ?  cssClassCoversionDictionary[slide.textPlacement] : "center-center";
        let image = slide.image ? slide.image.src : null;
        let slideContent =
        <div className={"hosports-slider-slide "+heightClass}>
          <div className={'hosports-slider-slide-foreground '+textPlacementClass}>
            <div className={"hosports-slider-slide-box "+this.props.theme}>
              {slide.title &&
                <h4 className='hosports-slider-slide-title full-width' style={{color:color}}>
                  {slide.title}
                </h4>
              }
              {slide.subtitle &&
                <h5 className='hosports-slider-slide-subtitle uppercase full-width tiny-padding' style={{color:color}}>
                  {slide.subtitle}
                </h5>
              }
              {slide.description &&
                <p className='hosports-slider-slide-description subheading' style={{color:color}}>
                  {slide.description}
                </p>
              }
              {slide.link &&
                <div className="hosports-slider-slide-button">
                  <a href={slide.link.linkUrl.destinationUrl}>
                    <Button text={slide.link.linkText} backgroundColor={this.props.theme === 'dark' ? '#fff' : '#000'} color={this.props.theme === 'dark' ? '#000' : '#fff'} />
                  </a>
                </div>
              }
            </div>
          </div>
          <div className={`hosports-slider-slide-tint tint ${ slide.tint }`} />
          {image &&
            <div className='hosports-slider-slide-background' style={{backgroundImage:`url(${ image })`}} />
          }
        </div>

        let videoId = slide.video ? GetYoutubeIdFromUrl(slide.video) : null;
        let videoSlideContent = null;
        if(videoId){
          videoSlideContent =
          <YoutubeBackground
            nocookie={true}
            playerOptions={{
              rel:0,
              modestbranding:1,
              controls:0,
              loop:1
            }}
            videoId={videoId}
            className={'video-player-container'}
            >
          </YoutubeBackground>
        }
        return videoSlideContent ? videoSlideContent : slideContent;
      })}
     </Slider>
    </div>
    );
 }
}

export const cssClassCoversionDictionary = {
  threeQuarter:'three-quarter',
  half:'half',
  quarter:'quarter',
  full:'full',
  centerCenter:'center-center',
  leftCenter:'left-center',
  rightCenter:'right-center',
  bottomLeft:'bottom-left',
  bottomRight:'bottom-right',
  bottomCenter:'bottom-center',
  topLeft:'top-left',
  topRight:'top-right',
  topCenter:'top-center'
};

 export default BaseSlider;
